export type QuestionLogicType = 
    | 'MATCH_WHO_WILL_WIN' 
    | 'MATCH_WILL_DRAW_END' 
    | 'MATCH_SCORE_FIRST' 
    | 'MATCH_BOTH_TEAMS_TO_SCORE' 
    | 'MATCH_FINAL_SCORE' 
    | 'MATCH_TOTAL_ODD_OR_EVEN' 
    | 'MATCH_MORE_THAN_X_GOALS_IN_HALF' 
    | 'SECOND_HALF_WHO_SCORES_NEXT' 
    | 'SECOND_HALF_CURRENTLY_LEADING_WIN_MATCH' 
    | 'SECOND_HALF_MORE_GOALS_THAN_FIRST_HALF' 
    | 'LATE_WILL_BE_GOAL_TILL_END' 
    | 'LATE_WILL_MATCH_END_CURRENT_SCORE' 
    | 'LATE_WHO_SCORES_LAST_GOAL' 
    | 'LATE_WILL_LOOSING_TEAM_DRAW' 
    | 'GOAL_NEXT_X_MINUTES' 
    | 'NEXT_GOAL_BY_TEAM' 
    | 'EVENT_YELLOW_CARD'
    | 'EVENT_RED_CARD'
    | 'EVENT_PENALTY'
    | 'EVENT_CORNER'
    | 'EVENT_GOAL_PLAYER'
    | 'CUSTOM';

export const QUESTION_LOGIC_OPTIONS: QuestionLogicType[] = [
    'MATCH_WHO_WILL_WIN',
    'MATCH_WILL_DRAW_END',
    'MATCH_SCORE_FIRST',
    'MATCH_BOTH_TEAMS_TO_SCORE',
    'MATCH_FINAL_SCORE',
    'MATCH_TOTAL_ODD_OR_EVEN',
    'MATCH_MORE_THAN_X_GOALS_IN_HALF',
    'SECOND_HALF_WHO_SCORES_NEXT',
    'SECOND_HALF_CURRENTLY_LEADING_WIN_MATCH',
    'SECOND_HALF_MORE_GOALS_THAN_FIRST_HALF',
    'LATE_WILL_BE_GOAL_TILL_END',
    'LATE_WILL_MATCH_END_CURRENT_SCORE',
    'LATE_WHO_SCORES_LAST_GOAL',
    'LATE_WILL_LOOSING_TEAM_DRAW',
    'GOAL_NEXT_X_MINUTES',
    'NEXT_GOAL_BY_TEAM',
    'EVENT_YELLOW_CARD',
    'EVENT_RED_CARD',
    'EVENT_PENALTY',
    'EVENT_CORNER',
    'EVENT_GOAL_PLAYER',
    'CUSTOM'
];
